import React,{useEffect, useState} from 'react'

import { Link} from 'react-router-dom'
import {Container,Row,Col,OverlayTrigger,Tooltip, Button} from 'react-bootstrap'
import Card  from '../../../components/Card'

import DirectorTable_ from '../../../database/table/director'

import Swal from 'sweetalert2'
import axios from 'axios'

import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons.js";
import "datatables.net-buttons/js/buttons.colVis.js";
import "datatables.net-buttons/js/buttons.flash.js";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import $ from "jquery";


const AddNewDirector =() =>{
  
    Swal.fire({
        title: 'Novo Mentor',
        html: '<input id="swal-input1" placeholder="Nome" class="swal2-input">' + 
        '<textarea id="swal-input2" placeholder="Descrição"  class="swal2-input"></textarea>',
        focusConfirm: false,
        confirmButtonText: '<i class="fa fa-thumbs-up"></i> Cadastrar',
        confirmButtonAriaLabel: 'Thumbs up, great!',
        showCancelButton: true,
        cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
        cancelButtonColor: '#d33',
        preConfirm: () => {
          return [
            document.getElementById('swal-input1').value,
            document.getElementById('swal-input2').value
          ]
        },
        }).then((result) => {
            //decode result
            const [name,description] = result.value
            if(name && description){
                  //swal with loading screen

                    const data = new FormData();
                    data.append("desname", name);
                    data.append("desdescription", description);
                    

                    Swal.fire({
                        title: 'Autenticando...',
                        icon: 'warning',
                        html: 'Aguarde enquanto validamos os dados...',
                        allowEscapeKey: false,
                        allowEnterKey: false,
                        showConfirmButton: false,
                        didOpen: () => {
                            Swal.showLoading()
                            //Axios Call
                            axios({
                                method: 'post',
                                url: process.env.REACT_APP_URL + '/api/director/register',
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                    'Accept': 'application/json'
                                },
                                data : data
                            })
                            .then(function (response) {
                                    if(response.data){
                                        Swal.close()
                                        Swal.fire({
                                            title: 'Atualizado com Sucesso!',
                                            text: "Dados atualizados com sucesso!",
                                            icon: 'success',
                                            confirmButtonText: 'OK'
                                        }).then((result) => {
                                            if (result.value) {
                                                window.location.reload()
                                            }
                                        })

                                    }
                            })
                            .catch(error => {
                                    //Close Loading Modal
                                    Swal.close();
                                    //Show Error
                                    Swal.fire({
                                        title: 'Ocorreu um erro!',
                                        text: error.response,
                                        icon: 'error',
                                        confirmButtonText: 'OK'
                                    })
                            })

                        },
                        allowOutsideClick: () => !Swal.isLoading()
                    })
            }else{
                Swal.fire(
                    'Mentor Não Criado!',
                    'Por favor, preencha todos os campos!',
                    'error'
                )
            }
    })
}



const DirectorTable = new DirectorTable_()

function EditMentor(director){
    Swal.fire({
        title: 'Editar Mentor',
        html: '<input id="swal-input1" value="'+director.desname+'" placeholder="Nome do Mentor" class="swal2-input">' +
        '<textarea id="swal-input2" placeholder="Descrição do Mentor"  class="swal2-input">'+director.desdescription+'</textarea>',
        focusConfirm: false,
        confirmButtonText: '<i class="fa fa-thumbs-up"></i> Atualizar Mentor',
        confirmButtonAriaLabel: 'Thumbs up, great!',
        showCloseButton: true,
        closeButtonText: '<i class="fa fa-thumbs-down"></i> closear',
        closeButtonColor: '#d33',
        preConfirm: () => {
            return [
                document.getElementById('swal-input1').value,
                document.getElementById('swal-input2').value
            ]
        }
    }).then((result) => {
        //decode result
        const [name,description] = result.value

        if(name && description){

            const data = new FormData();

            data.append("desname", name);
            data.append("desdescription", description);
            data.append("iddirector", director.id);

            Swal.fire({
                title: 'Autenticando...',
                icon: 'warning',
                html: 'Aguarde enquanto validamos os dados...',
                allowEscapeKey: false,
                allowEnterKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading()
                    //Axios Call
                    axios({
                        method: 'post',
                        url:  process.env.REACT_APP_URL + '/api/director/update',
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Accept': 'application/json'
                        },
                        data : data
                    })
                    .then(function (response) {
                            if(response.data){
                                Swal.close()
                                Swal.fire({
                                    title: 'Atualizado com Sucesso!',
                                    text: "Dados atualizados com sucesso!",
                                    icon: 'success',
                                    confirmButtonText: 'OK'
                                }).then((result) => {
                                    if (result.value) {
                                        window.location.reload()
                                    }
                                })
                            }
                        })
                        .catch(error => {
                                //Close Loading Modal
                                Swal.close();
                                //Show Error
                                Swal.fire({
                                    title: 'Ocorreu um erro!',
                                    text: error.response,
                                    icon: 'error',
                                    confirmButtonText: 'OK'
                                })
                        })
                },
                allowOutsideClick: () => !Swal.isLoading()
            })
        }else{
            Swal.fire(
                'Mentor Não Atualizado!',
                'Por favor, preencha todos os campos!',
                'error'
            )
        }
    }).catch(error => {
       
    })
}

function DeleteMentor(mentor){
    Swal.fire({
        title: 'Você tem certeza de que deseja remover este mentor?',
        text: "Você não poderá reverter isso! Este mentor será removido das listas de mentores!",
        focusConfirm: false,
        confirmButtonText: '<i class="fa fa-thumbs-up"></i> Remover Mentor!',
        confirmButtonAriaLabel: 'Thumbs up, great!',
        showCancelButton: true,
        cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
        cancelButtonColor: '#d33',
        }).then((result) => {

            if (result.value) {
                console.log(result)
                const data = new FormData();
                data.append("id", mentor.id);
                Swal.fire({
                    title: 'Autenticando...',
                    icon: 'warning',
                    html: 'Aguarde enquanto validamos os dados...',
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        Swal.showLoading()
                        //Axios Call
                        axios({
                            method: 'post',
                            url: process.env.REACT_APP_URL + '/api/director/delete',
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                'Accept': 'application/json'
                            },
                            data : data
                        })
                        .then(function (response) {
                                if(response.data){
                                    Swal.close()
                                    Swal.fire({
                                        title: 'Atualizado com Sucesso!',
                                        text: "Dados atualizados com sucesso!",
                                        icon: 'success',
                                        confirmButtonText: 'OK'
                                    }).then((result) => {
                                        if (result.value) {
                                            window.location.reload()
                                        }
                                    })
                                }
                        })
                        .catch(error => {
                                //Close Loading Modal
                                Swal.close();
                                //Show Error
                                Swal.fire({
                                    title: 'Ocorreu um erro!',
                                    text: error.response,
                                    icon: 'error',
                                    confirmButtonText: 'OK'
                                })
                        })
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                })
            }
    })
}

const CategoryList = () => { 

    const [director,setDirectors] = useState([])

    useEffect( () =>{
       DirectorTable.get().then(res => {
        setDirectors(res.filter(director => director.isactive === 1))
      })
    }, []);

    //export function EditCategory to be used in the table
    window.EditMentor = EditMentor;
    window.DeleteMentor = DeleteMentor;
    

     //if table already loaded then destroy it
     if ($.fn.DataTable.isDataTable("#table")) {
        $("#table").DataTable().destroy();
    }


    if (director.length > 0) {
        console.log({
            data: director
        })
        const table = $("#table").DataTable({
            data: director,
            columns: [
                { data: "id" },
                { data: "desname" },
                { data: "desdescription" },
                { data: "dtregister" },
            ],
            //style last column
            columnDefs: [
                {
                    targets: 4,
                    render: function (data, type, row) {
                        let frow = JSON.stringify(row).replace(/"/g, "'");
                        //button with row object onclick
                        return `<button class="btn-sm btn-primary" onclick="EditMentor(${frow})"><i class="lar ri-pencil-line"></i></button>
                                <button class="btn-sm btn-danger"  onclick="DeleteMentor(${frow})"><i class="ri-delete-bin-2-line"></i></button>`;
                    }
                },
            ],
            //hide "shoe entries button"
            lengthChange: false,
            //change position of "search" input
            dom: 'lrtip',
        });
        // #column3_search is a <input type="text"> element
        $('#input-search-data').on( 'keyup', function () {
            //saerch from table by name in all columns
            table.search( this.value ).draw();
        } );
    }

    return (
            <> 
                <Container fluid>
                    <Card>
                        <Card.Header className="d-flex justify-content-between no-bottom-border" >
                            <Card.Header.Title>
                                <h4 className="card-title">Lista de Diretores</h4>
                            </Card.Header.Title>
                            <div className="iq-card-header-toolbar d-flex align-items-center">
                                <Button onClick={AddNewDirector} className="btn btn-primary">Adicionar Mentor</Button>
                            </div>
                        </Card.Header>
                        <div className="datatable-input-holder">
                            <input type="text" className="form-control datatable-search" id="input-search-data" placeholder="Pesquisar" />
                        </div>
                        <Card.Body>
                        <div class="table-responsive p-0 pb-2">
                            <table id="table" className="table align-items-center justify-content-center mb-0">
                                <thead>
                                    <tr>
                                        <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">ID</th>
                                        <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">Título</th>
                                        <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">Descrição</th>
                                        <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">Registro</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody></tbody>
                            </table>
                        </div>
                        </Card.Body>
                    </Card>
                </Container>
            </>
    )
}
export default CategoryList;